import React from "react";
import './ButtonGris.scss'
const ButtonGris = ({children,width='100%',onClick,className})=>
{   
    return(
       <button className={`ButtonGris ${className}`} onClick={onClick} style={{width:width}}>{children}</button>
    )

}
export default ButtonGris